<template>
    <section class="container w-screen  ml-auto mr-auto h-auto lg:mt-16 lg:w-1/2  content-center">
        <h1 class="title text-center text-4xl">S'inscrire</h1>
        <div class="bg-white shadow-xl rounded px-8 pt-6 pb-8 mb-4 flex flex-col my-2 align-middle">
            <div class="-mx-3 md:flex mb-6">
                <div class="md:w-1/2 px-3 mb-6 md:mb-0">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-first-name">
                        Prénom
                    </label>
                    <input class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-red rounded py-3 px-4 mb-3" id="grid-first-name" type="text" placeholder="Jane">
<!--                    <p class="text-red text-xs italic">Please fill out this field.</p>-->
                </div>
                <div class="md:w-1/2 px-3">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-last-name">
                        Nom
                    </label>
                    <input class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-3 px-4" id="grid-last-name" type="text" placeholder="Doe">
                </div>
            </div>


            <div class="-mx-3 md:flex mb-6">
                <div class="md:w-full px-3">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-email">
                        Adresse mail
                    </label>
                    <input class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-3 px-4 mb-3" id="grid-email" type="email" placeholder="jeanfrancois@gmail.com">
<!--                    <p class="text-grey-dark text-xs italic">Make it as long and as crazy as you'd like</p>-->
                </div>
            </div>


            <div class="-mx-3 md:flex mb-6">
                <div class="md:w-full px-3">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-password">
                        Mot de passe
                    </label>
                    <input class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-3 px-4 mb-3" id="grid-password" type="password" placeholder="******************">
                    <!--                    <p class="text-grey-dark text-xs italic">Make it as long and as crazy as you'd like</p>-->
                </div>
            </div>


            <div class="-mx-3 md:flex mb-2">
                <div class="md:w-1/2 px-3 mb-6 md:mb-0">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-city">
                        Ville
                    </label>
                    <input class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-3 px-4" id="grid-city" type="text" placeholder="Paris">
                </div>
                <div class="md:w-1/2 px-3">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-state">
                        Region
                    </label>
                    <div class="relative">
                        <select class="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker py-3 px-4 pr-8 rounded" id="grid-state">
                            <option>Pas centre</option>
                            <option>Centre</option>
                            <option>Pas centre</option>
                        </select>
                        <div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
                        </div>
                    </div>
                </div>
                <div class="md:w-1/2 px-3">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-zip">
                        Code Postale
                    </label>
                    <input class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-3 px-4" id="grid-zip" type="text" placeholder="72000">
                </div>
            </div>
            <div class=" mb-2 mt-10  justify-center text-center relative  absolute inset-0 flex items-center justify-center">

                <button class="w-1/3 justify-center   bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 border border-blue-700 container  rounded flex  tex-content-center ">
                    Inscription
                </button>

            </div>
            <p class="text-center text italic">Vous avez déja un compte? <router-link to="/login" class="hover:underline text-blue-600"> Connectez-vous</router-link> </p>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Register"
    }
</script>

<style scoped>

</style>
